import { Tabs } from "@radix-ui/themes";
import { TbReport } from "react-icons/tb";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { PersonsReport } from "./persons/PersonsReport";
import { Tab, TabType, useTabsStore } from "../../stores/TabsStore";
import { Separator } from "../../ui/Separator";
import * as cTabs from "../../ui/TabsNav";
import ReportsHome from "./ReportsHome";
import { useAppStore } from "../../stores/RootStore";
import { t } from "i18next";
import { useFetch } from "../../hooks/useFetch";
import { useEffect } from "react";
import { CustomReport } from "../../types/types";
import { DateTime } from "luxon";
import { getBaseTemplateForTabType } from "../../components/Templates/templates";
import { EquipmentsReport } from "./equipments/EquipmentsReport";


let id = 0;

const ReportsTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {currentSite, reports} = useAppStore()
  const {activeReport, setActiveReport, tabs, addTab, closeTab, activeTabId, reorderTabs} = useTabsStore()
  const baseSetActiveTab = useTabsStore((store) => store.setActiveTab);

  const [{ response, isLoading }, doFetchReport] = useFetch(`/directories/custom_data_storages/${activeReport?.name}`);

  useEffect(() => {
    if(!activeReport || !activeReport.name) { 
      return;
    }

    if(["equipments", "persons", "divisions"].includes(activeReport.name)) {
      addNewTab({name: activeReport.title, type: activeReport.name as TabType})
      return;
    }

    if(reports?.map(r => r.name).includes(activeReport.name)) {
      doFetchReport()
    } else {
      return;
    }

  },[activeReport])

  useEffect(() => {
    if (!response) return;

    const responseData = response.data as unknown as CustomReport;
    const data = responseData.attributes.data;

    // Добавление нового таба + фикс разницы свойств объекта, который приходит от бэкэнда
    addTab({
      id: `${id}`,
      dataIsLoaded: false,
      dataIsLoading: true,
      title: `${data.title}`,
      type: data.type,
      url: data.url,
      view: "table",
      template: data.template,
      defaultValues: {
        ...data.default_values,
        dates: {
          from: new Date(data.default_values.dates.from),
          to: new Date(data.default_values.dates.to),
        },
        shifts: data.default_values.shifts.map((shift: { start_at: string; end_at: string }) => {
          return { ...shift, start_at: DateTime.fromISO(shift.start_at), end_at: DateTime.fromISO(shift.end_at) };
        }),
      },
      options: {
        ...data.options,
        savedTabData: {
          name: activeReport?.name!,
          title: activeReport?.title,
          access_type: responseData.attributes.access_type,
        },
        blocks: data.options.blocks?.map((block: { type: string; options: { calculation_type: any } }) => {
          if (block.type == "calculated_block")
            return { ...block, options: { ...block.options, calculation_type: block.options.calculation_type } };
          else return block;
        }),
      },
      reportOptions: {
        type: null,
        items: []
      }
    });

    id++;
  }, [response]);

  const addNewTab = (item: {name: string; type: TabType;}) => {
    if (tabs.find((tab) => tab.type === item.type && !tab.options)) {
      setActiveTab(tabs.find((tab) => tab.type === item.type && !tab.options)?.id!);
      return;
    }
    addTab({
      id: `${id}`,
      dataIsLoaded: false,
      dataIsLoading: false,
      title: item.name,
      type: item.type,
      url: `/analytics/${item.type}`,
      view: "table",
      template: getBaseTemplateForTabType(item.type),
      reportOptions: {
        type: null,
        items: []
      }
    });
    id++;
  };

  const getComponentByType = (tab: Tab) => {
    switch (tab.type) {
      case "equipments":
        return <EquipmentsReport tab={tab} />;
      case "persons":
        return <PersonsReport tab={tab} />;
    }
  };

  const setActiveTab = (tabId: string | null) => {
    if(!tabId) {
      let activeTab = document.querySelector(".chrome-tab[active]");
      activeTab?.removeAttribute("active");
      baseSetActiveTab(tabId);
    } else {
      baseSetActiveTab(tabId);
    }
  };

  return (
    <>
      {tabs && tabs.length > 0 ?
      <div className="flex">
        <cTabs.Tabs
          className="flex-none w-full"
          darkMode={false}
          onTabClose={closeTab}
          onTabReorder={reorderTabs}
          onTabActive={setActiveTab}
          tabs={[...tabs]}
        />
        <Separator className="flex-none" orientation="vertical"/>
        <div className="flex-none flex w-14 h-14 items-center justify-center">
          <div className="px-3 data-[state='open']:text-white text-primary data-[state='open']:bg-primary">
            <TbReport size={24} onClick={() => setActiveTab(null)}/>
          </div>
        </div>
      </div>
      :
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center bg-background">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}><span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span></NavLink>
          <span>/</span>
          <span className="font-medium">{t("analytica")}</span>
        </div>
      </div>
      }
      <Separator />
      {activeTabId ? 
        <Tabs.Root value={activeTabId} className="flex w-full h-full overflow-hidden">
          {tabs.map((tab) => (
            <Tabs.Content
              key={tab.id}
              value={tab.id}
              className="data-[state=active]:flex data-[state=active]:flex-col data-[state=active]:w-full"
            >
              {getComponentByType(tab)}
            </Tabs.Content>
          ))}
        </Tabs.Root>
        :
        <ReportsHome />
      }
    </>
  );
};

export default ReportsTabs;
